
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/privacy-policy",
      function () {
        return require("private-next-pages/terminal/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/privacy-policy"])
      });
    }
  